//namespace Pacem {
var root;
/** the overall customelement prefix */
export const P = (root = window['Pacem'])?.Configuration?.prefix ?? 'pacem';
export const PCSS = root?.Configuration?.css ?? P;
//}
